import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';


export default function Deleteuserloan()
{
    const navigate = useNavigate();
    const date = new Date().toISOString().slice(0,10);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [userid, setUserid]= useState(0);
    const [user, setUser] = useState([]);
    const APP_NAME = process.env.REACT_APP_NAME;

    useEffect(() =>
    {
        fetch(API_URL+"api/Userloan/GetLoanStatus?userid="+ userid)
        .then(response => response.json()).then(data => {setUser(data)});
    },[userid])

    console.log(user);

    function loandetails()
    {
                
            if(user.length > 0 && user[0].LoanReturned === 0)
            {
                document.getElementById('edate').value = user[0].EntryDate.slice(0,10);
                document.getElementById('fdate').value = user[0].ForDate.slice(0,10);
                document.getElementById('amount').value = user[0].LoanAmount;
            }
            else 
            {
                noloandialog();
            }

    }

    function deleteuserloan()
    {
        fetch(API_URL+"api/Userloan/DeleteUserLoan?userid="+ userid ,{method:"PUT",body:null}).then(res=>res.json())
        .then(()=>{});

        showOKdialog();
    }
    console.log(user)
    console.log(userid);

    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
        dialog.showModal();
    }

    function noloandialog()
    {
    const dialog = document.getElementById('noloanDialog');
    dialog.showModal();
    }

    function closenoloandialog()
    {
    const dialog = document.getElementById('noloanDialog');
    dialog.close();
    }

   
    return(
        <>
        <div className="reportheader"> {APP_NAME}
            
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"goldenrod",height:"25px",width:"100%",textAlign:"center",zIndex:-1,marginBottom:"20px"}}>Delete UserLoan</div>
        
        <div>
            <fieldset>
            <label for ="userid" style ={{marginLeft:"5px"}}>User ID</label>
            <input id = "userid" onChange={(e)=>{setUserid(e.target.value === '' ? 0 : (e.target.value))}} style ={{marginLeft:"10px",width:"170px",height: "30px"}}></input>
            <button type="button" style={{ height: "34px", width: "20%", marginLeft: "10px", marginTop: "10px", backgroundColor: "orange", color: "white", fontSize: "14px", fontWeight: "bolder", borderRadius: "5px" }} onClick={() => {loandetails()}} >Search</button><br/>
            </fieldset>
            <fieldset>
            <label for = "edate" style ={{marginLeft:"10%"}}>Entry Date</label>
            <input id = "edate" type="date"  style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} readOnly></input><br/><br/>
            <label for = "fdate" style ={{marginLeft:"10%"}}>For Date</label>
            <input id = "fdate" type="date" style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}} readOnly></input><br/><br/>
            <label for = "amount" style ={{marginLeft:"10%"}}>Loan Amount</label>
            <input id = "amount" style = {{height:"30px",width:"80%",marginLeft:"10%",marginBottom:"20px"}}></input>
            </fieldset>
        </div>
        
        <div style ={{marginTop:"70px"}}>
        <button type = "button"  className='actionbuttons' onClick={()=>{deleteuserloan()}}>Delete</button> 
        <button type = "button"  className='actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/user')}}>Cancel</button>
        </div>
        <dialog id = "myDialog" className="okdialog">
            <p>User Loan Deleted</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/user')}}>OK</button>
        </dialog>

        <dialog id = "noloanDialog" className="okdialog">
            <p>No Loan Found For Given User</p>
            <button className="okdialogbutton" onClick={()=>{closenoloandialog()}}>OK</button>
        </dialog>

           
        </>
    )
}